import type { MeDTO, MembershipDTO } from "../query/me.js";

/** Eigener Wert im Speicher, damit „als Privatperson" eine Wahl bleibt und kein Fehlen. */
export const PRIVAT = "privat";

/** Die wirksame Ansicht: eine Mitgliedschaft, eine eingenommene Rolle oder privat. */
export interface ActiveSelection {
  active: MembershipDTO | null;
  /** Die Rolle stammt nicht aus einer Mitgliedschaft, sondern ist intern eingenommen. */
  assumed: boolean;
}

/**
 * Leitet die Ansicht aus dem Gespeicherten ab, statt sie festzuhalten: eine entzogene
 * Rolle, ein gesperrter oder gelöschter Mandant oder ein Konto, das nicht mehr intern
 * ist, soll die Oberfläche nicht auf etwas zeigen lassen, das es nicht mehr gibt.
 */
export function resolveSelection(
  me: MeDTO | null | undefined,
  storedTenant: string | null,
  storedRole: string | null,
): ActiveSelection {
  const memberships = me?.memberships ?? [];
  if (storedTenant === PRIVAT) {
    return { active: null, assumed: false };
  }

  const internal = me?.internal;
  if (internal && storedRole) {
    const tenant = internal.tenants.find((entry) => entry.tenantId === storedTenant);
    const role = internal.roles.find((entry) => entry.role === storedRole);
    if (tenant && role) {
      return {
        active: {
          tenantId: tenant.tenantId,
          tenantSlug: tenant.tenantSlug,
          tenantName: tenant.tenantName,
          role: role.role,
          permissions: role.permissions,
          // Eine eingenommene Rolle gilt für alle Angebote (IdentityService.internalContext).
          limited: false,
        },
        assumed: true,
      };
    }
  }

  // Ohne gültige Wahl: die erste Mitgliedschaft, sonst Privatperson. Wer im Dienst ist,
  // soll nicht erst umschalten müssen.
  const treffer = memberships.find((entry) => entry.tenantId === storedTenant);
  return { active: treffer ?? memberships[0] ?? null, assumed: false };
}
